var _class, _temp, _initialiseProps;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';
import { Util } from '../index';
import ContenidoVentana from './contenido-ventana';
import VisorImagenes from '../visor-imagenes/components/visor-imagenes';
import ContenidosVisor from '../visor-imagenes/components/contenidos-visor';
import AreaImagen from '../visor-imagenes/components/area-imagen';
import BotoneraAreaImagenVisorDerecha from '../visor-imagenes/components/botonera-area-imagen-visor-derecha';
import BotoneraAreaImagenVisorIzquierda from '../visor-imagenes/components/botonera-area-imagen-visor-izquierda'; // const vinculoAbrirZona = (libroId, numPagina, numPaso) => ({
//     vinculo: `funcion,abrirZona:${libroId}${Util.pad3(numPagina)}.${numPaso}`
// })
// const recurso = (libroId, numHistoria, num, version, extension) => {
//     return `contenido/${libroId}${Util.pad2(numHistoria)}${Util.pad2(num)}${version}.${extension}`
// }

var getImageSrc = function getImageSrc(libroId, numHistoria, numPaso) {
  return 'contenido/' + libroId + Util.pad2(numHistoria) + Util.pad2(Number(numPaso)) + '.png';
};

var getImageSrcA = function getImageSrcA(libroId, numHistoria, numPaso) {
  return 'contenido/' + libroId + Util.pad2(numHistoria) + Util.pad2(Number(numPaso)) + 'a.png';
};

var getAudioSrc = function getAudioSrc(libroId, numHistoria, numPaso) {
  return 'contenido/' + libroId + Util.pad2(numHistoria) + Util.pad2(Number(numPaso)) + '.mp3';
};

var ContenidoTipoHistoriaAutoSegundaVentana = (_temp = _class = function (_Component) {
  _inherits(ContenidoTipoHistoriaAutoSegundaVentana, _Component);

  function ContenidoTipoHistoriaAutoSegundaVentana(props) {
    _classCallCheck(this, ContenidoTipoHistoriaAutoSegundaVentana);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    var libroId = props.libroId,
        numHistoria = props.numHistoria;
    var numPaso = !isNaN(props.numPaso) ? props.numPaso : 1;
    _this.state = {
      versionImagen: 'a',
      // en segunda ventana, siempre version de imagen a
      imageSrc: getImageSrc(libroId, numHistoria, numPaso),
      imageSrcA: getImageSrcA(libroId, numHistoria, numPaso),
      audioSrc: getAudioSrc(libroId, numHistoria, numPaso),
      numPaso: numPaso
    };
    _this.audioRef = React.createRef(); // window.console.log({props, state: this.state}) 

    return _this;
  }

  ContenidoTipoHistoriaAutoSegundaVentana.prototype.componentDidMount = function componentDidMount() {
    this.audioRef.current.addEventListener('ended', this.handleSiguiente, false);
  };

  ContenidoTipoHistoriaAutoSegundaVentana.prototype.componentWillUnmount = function componentWillUnmount() {
    this.audioRef.current.removeEventListener('ended', this.handleSiguiente, false);
  };

  ContenidoTipoHistoriaAutoSegundaVentana.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var numPaso = this.state.numPaso;

    if (prevState.numPaso !== numPaso) {
      var _props = this.props,
          libroId = _props.libroId,
          numHistoria = _props.numHistoria;
      this.setState({
        imageSrc: getImageSrc(libroId, numHistoria, numPaso),
        imageSrcA: getImageSrcA(libroId, numHistoria, numPaso),
        audioSrc: getAudioSrc(libroId, numHistoria, numPaso)
      });
    }
  };

  ContenidoTipoHistoriaAutoSegundaVentana.prototype.render = function render() {
    var txtNumVineta = this.props.txtNumVineta;
    var _state = this.state,
        audioSrc = _state.audioSrc,
        imageSrc = _state.imageSrc,
        imageSrcA = _state.imageSrcA,
        playing = _state.playing;
    return React.createElement(ContenidoVentana, null, React.createElement(VisorImagenes, {
      clasesExtra: 'historia',
      automatico: true
    }, React.createElement(AreaImagen, null, React.createElement(BotoneraAreaImagenVisorIzquierda, {
      txtNumVineta: txtNumVineta
    }), React.createElement(ContenidosVisor, {
      src: imageSrc,
      srcA: imageSrcA,
      versionImagen: 'a'
    }), React.createElement(BotoneraAreaImagenVisorDerecha, {
      onPlay: this.handlePlay,
      playing: playing
    }))), React.createElement('audio', {
      src: audioSrc,
      ref: this.audioRef
    }));
  };

  return ContenidoTipoHistoriaAutoSegundaVentana;
}(Component), _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handlePlay = function () {
    // window.console.log("handlePlay " + this.state.playing, this.audio.current.paused)
    var playing = !_this2.state.playing;
    var audio = _this2.audioRef.current;

    if (playing) {
      audio.load();
      audio.play();
    } else {
      audio.pause();
    }

    _this2.setState({
      playing: playing
    });
  };

  this.handleSiguiente = function () {
    var audio = _this2.audioRef.current;
    var _props2 = _this2.props,
        libroId = _props2.libroId,
        numHistoria = _props2.numHistoria,
        numPasos = _props2.numPasos;
    var numPaso = _this2.state.numPaso === numPasos ? 1 : _this2.state.numPaso + 1;
    var playing = numPaso > 1;

    _this2.setState({
      numPaso: numPaso,
      imageSrc: getImageSrc(libroId, numHistoria, numPaso),
      imageSrcA: getImageSrcA(libroId, numHistoria, numPaso),
      audioSrc: getAudioSrc(libroId, numHistoria, numPaso),
      playing: playing
    }, function () {
      audio.load();

      if (playing) {
        audio.play();
      }
    });
  };
}, _temp);
ContenidoTipoHistoriaAutoSegundaVentana.propTypes = process.env.NODE_ENV !== "production" ? {
  libroId: t.string,
  numPagina: t.number,
  numHistoria: t.number,
  numPaso: t.number,
  numPasos: t.number,
  // numZona: t.number,
  txtNumVineta: t.string,
  children: t.any
} : {};
export default ContenidoTipoHistoriaAutoSegundaVentana;